import React, {useState, useEffect} from 'react';
import AboutUsStory from './AboutUsStory';
import PopupAboutUs from './AboutUsPopup';

const MISSION_CONTENT = {
    title: 'Sứ mệnh',
    title_en: 'Mission',
    short_description:
        'Mang đến dịch vụ chăm sóc sức khỏe chất lượng cao, an tâm, nhân văn và dễ tiếp cận cho mọi người dân, lấy người bệnh làm trung tâm, lấy chuyên môn làm nền tảng và lấy đổi mới, sáng tạo làm động lực phát triển.',
    short_description_en:
        'Provide high-quality, safe, humane, and easily accessible healthcare services for all citizens, with a patient-centered approach, grounded in professional expertise, and driven by innovation and creativity.',
    more_description:
        'Mang đến dịch vụ chăm sóc sức khỏe chất lượng cao, an tâm, nhân văn và dễ tiếp cận cho mọi người dân, lấy người bệnh làm trung tâm, lấy chuyên môn làm nền tảng và lấy đổi mới, sáng tạo làm động lực phát triển.',
    more_description_en:
        'Provide high-quality, safe, humane, and easily accessible healthcare services for all citizens, with a patient-centered approach, grounded in professional expertise, and driven by innovation and creativity.',
};

const VISION_CONTENT = {
    title: 'Tầm nhìn 2035',
    title_en: 'Vision 2035',
    short_description:
        'Trở thành tập đoàn y tế tư nhân hàng đầu khu vực phía Bắc, được công nhận về dịch vụ chăm sóc sức khỏe chất lượng cao, lấy người bệnh làm trung tâm thông qua hệ thống bệnh viện hiện đại, chuyên môn lâm sàng xuất sắc, đổi mới sáng tạo và các dịch vụ chăm sóc sức khỏe toàn diện.',
    short_description_en:
        "To become the leading private healthcare group in Vietnam's Northern Region, recognized for delivering high-quality, patient-centered healthcare through a modern hospital network, clinical excellence, innovation, and comprehensive healthcare services.",
    more_description:
        'Trở thành tập đoàn y tế tư nhân hàng đầu khu vực phía Bắc, được công nhận về dịch vụ chăm sóc sức khỏe chất lượng cao, lấy người bệnh làm trung tâm thông qua hệ thống bệnh viện hiện đại, chuyên môn lâm sàng xuất sắc, đổi mới sáng tạo và các dịch vụ chăm sóc sức khỏe toàn diện.',
    more_description_en:
        "To become the leading private healthcare group in Vietnam's Northern Region, recognized for delivering high-quality, patient-centered healthcare through a modern hospital network, clinical excellence, innovation, and comprehensive healthcare services.",
};

export default function AboutUsHome(props) {
    const {aboutus} = props;
    const mission = {
        ...aboutus.WEB_ABOUT_MISSION?.value,
        ...MISSION_CONTENT,
    };
    const vision = {
        ...aboutus.WEB_ABOUT_VISION?.value,
        ...VISION_CONTENT,
    };
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const handleOpenPopup = data => {
        setPopupData(data);
        setPopupOpen(true);
    };

    return (
        <section className="about-us">
            <AboutUsStory
                onOpenPopup={handleOpenPopup}
                story={aboutus.WEB_ABOUT_STORY_TNH?.value}
                mission={mission}
                vision={vision}
            />
            {popupOpen && (
                <PopupAboutUs
                    type={popupData.type}
                    title={popupData.title}
                    content={popupData.content}
                    image={popupData.image}
                    onClose={() => setPopupOpen(false)}
                />
            )}
        </section>
    );
}
